import { render, staticRenderFns } from "./receiveAndDetailDialog.vue?vue&type=template&id=32f657be&scoped=true&"
import script from "./receiveAndDetailDialog.vue?vue&type=script&lang=js&"
export * from "./receiveAndDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./receiveAndDetailDialog.vue?vue&type=style&index=0&id=32f657be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f657be",
  null
  
)

export default component.exports